import { useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Chip,
    Button,
    useTheme,
    Slide,
    Fade,
    keyframes,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BoltIcon from '@mui/icons-material/Bolt';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router';
const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.15); opacity: 0.9; }
  100% { transform: scale(1); opacity: 1; }
`;

export default function PromoStrip() {
    const [isVisible, setIsVisible] = useState(true);
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Slide direction="down" in={isVisible} mountOnEnter unmountOnExit timeout={500}>
            <Fade in={isVisible} timeout={600}>
                <Box
                    sx={{
                        width: '100%',
                        py: 1.2,
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        fontWeight: 500,
                        fontSize: '0.9rem',
                        color: '#fff',
                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                        boxShadow: '0 3px 10px rgba(0,0,0,0.12)',
                        mt: 2,
                        mb: 2,
                        overflow: 'hidden',
                    }}
                >
                    {/* Left icon */}
                    <BoltIcon
                        sx={{
                            mr: 1,
                            fontSize: 22,
                            color: 'yellow',
                            animation: `${pulse} 3s ease-in-out infinite`,
                        }}
                    />

                    {/* Message + CTA */}
                    <Typography
                        component="span"
                        sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}
                    >
                        <Chip
                            label="New"
                            size="small"
                            sx={{
                                mr:1.8,
                                backgroundColor: '#fff',
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                borderRadius: '4px',
                                animation: `${pulse} 2s ease-in-out infinite`,
                                '& .MuiChip-label': { px: 1.5, py: 0.3 },
                            }}
                        />
                        <span>Boost your recruitment game — meet the new Job Fair Candidates feature!</span>

                        <Button
                            onClick={() => navigate('/job-fair-candidates')}
                            variant="contained"
                            color="secondary"
                            size="small"
                            endIcon={<EastIcon />}
                            sx={{
                                ml: 4,
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                backgroundColor: '#fff',
                                color: theme.palette.primary.main,
                                borderRadius: '40px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                transition: 'all 0.25s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    backgroundColor: '#f8faff',
                                },
                            }}
                        >
                            Check Now
                        </Button>
                    </Typography>

                    {/* Close Button */}
                    <IconButton
                        size="small"
                        onClick={() => setIsVisible(false)}
                        sx={{
                            position: 'absolute',
                            right: 12,
                            color: '#fff',
                            opacity: 0.8,
                            '&:hover': { opacity: 1 },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Fade>
        </Slide>
    );
}
